import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { mediaQueries } from "./Themes";

const Nav = styled.nav`
  margin-top: 1.5rem;
  font-family: "Karla", sans-serif;
  font-style: normal;
  font-size: calc(0.45rem + 0.7vw);
  line-height: 1.8;

  ${mediaQueries(40)`
    font-size: calc(0.7rem + 0.4vw);
  `};
`;

const Label = styled.span`
  display: block;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.75em;
`;

const List = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.75rem;
  margin: 0;
`;

const Item = styled.li``;

const PageLink = styled(NavLink)`
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 0.2em;

  &:hover {
    opacity: 0.7;
  }
`;

const RelatedPages = ({ links }) => {
  if (!links || !links.length) return null;

  return (
    <Nav aria-label="Related pages">
      <Label>More</Label>
      <List>
        {links.map((link) => (
          <Item key={link.to}>
            <PageLink to={link.to}>{link.label}</PageLink>
          </Item>
        ))}
      </List>
    </Nav>
  );
};

export default RelatedPages;
